<template>
	<div class="watch-dashboard-widget appointments-widget">
		<div class="watch-dashboard-widget-header">
			<router-link :to="{ name: 'WatchAppointmentUpcoming', params: { user_uid: user_uid, watch_id: watch_id } }" class="header-link">
				<h1>{{ $t('base.general.next_appointment') }}</h1>
			</router-link>
		</div>
		<div class="watch-dashboard-widget-body">
			<spinner v-if="appointments.loading"/>
			<error-box v-else-if="appointments.error" :error="appointments.error"/>
			<div v-else>
				<div v-if="appointments.data.length" class="appointments">
					<router-link v-for="item in appointments.data" :key="item.id" :to="{ name: 'WatchAppointmentCalendar', params: { user_uid: user_uid, watch_id: watch_id } }" class="appointment">
						<div class="date-time">
							<div class="date">{{ date(item.date) }}</div>
							<div class="time">{{ time(item.date) }}</div>
						</div>
						<div class="details">
							<div class="name">{{ item.name }}</div>
							<div class="location">{{ item.location }}</div>
						</div>
					</router-link>
				</div>
				<p v-else>{{ $t('base.watch.no_appointments_today') }}</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: [
		'user_uid',
		'watch_id'
	],
	data () {
		return {
			appointments: {
				loading: false,
				data: [],
				error: null
			}
		}
	},
	watch: {
		'$route' () {
			this.getUpcoming()
		}
	},
	methods: {
		date (date) {
			return this.$moment(date).format('D MMM')
		},
		time (date) {
			return this.$moment(date).format('HH:mm')
		},
		getUpcoming () {
			this.appointments.loading = true
			this.$api.appointments.getUpcoming(this, this.user_uid, this.watch_id, this.$moment()).then(response => {
				this.$log.info('watch dashboard appointments', 'appointments.getUpcoming OK', response)()
				this.appointments.data = response.body
			}).catch(errors => {
				this.$log.error('watch dashboard appointments', 'appointments.getUpcoming ERROR', errors)()
				this.appointments.error = errors
			}).finally(() => {
				this.appointments.loading = false
			})
		}
	},
	mounted () {
		this.getUpcoming()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/widgets/AppointmentsWidget.vue